import { requestBuilder } from '../../../http/RequestBuilder';
import { type Beneficiary } from '../../types/Beneficiaries';

export const useGetBeneficiaries = requestBuilder.query<Beneficiary[]>({
    endpoint: () => '/api/beneficiary',
    queryKey: () => 'getUserBeneficiaries',
});
